import React from 'react';
import { Telephone, Envelope } from 'react-bootstrap-icons';
import '../../views/EjecutivoView.css';

const ViceIntendente = ({ ejecutivo }) => {
  return (
    <>
      {ejecutivo != null && (
        <div className="ejecutivo-box">
          <div className="ejecutivo-nombre">Viceintendente</div>
          <div className="ejecutivo-sub">{ejecutivo.viceIntendenteNombre}</div>
          <div className="ejecutivo-sub">
            <Envelope />{' '}
            <a className="ejecutivo-link" href={'mailto:' + ejecutivo.viceIntendenteEmail}>
              {ejecutivo.viceIntendenteEmail}
            </a>
          </div>
          <div className="ejecutivo-sub">
            <Telephone /> Teléfono {ejecutivo.viceIntendenteTelefono}
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(ViceIntendente);
